import { legacyApiResourceUrl } from "@ploy-lib/core";
import { BaseCamelCasedResource } from "./BasePlainResource";
export class RefinancingResource extends BaseCamelCasedResource {
    pk() {
        return this.contractId.toString();
    }
    static list() {
        const endpoint = super.list();
        return endpoint.extend({
            schema: [this],
            fetch: async (params) => {
                const data = await endpoint.fetch(params);
                return data?.rows ?? [];
            }
        });
    }
}
RefinancingResource.urlRoot = legacyApiResourceUrl("Refinancing/Load/REFINANCING");
export class FulfillmentResource extends RefinancingResource {
}
FulfillmentResource.urlRoot = legacyApiResourceUrl("Refinancing/Load/FULFILLMENT");
//# sourceMappingURL=RefinancingResource.js.map